import MuiButton from './MuiButton';
import MuiTextField from './MuiTextField';
import MuiInputBase from './MuiInputBase';
import MuiFilledInput from './MuiFilledInput';
import MuiAutocomplete from './MuiAutocomplete';
import MuiDivider from './MuiDivider';
import MuiInputLabel from './MuiInputLabel';
import MuiDialogContent from './MuiDialogContent';
import MuiSlider from './MuiSlider';
import MuiToggleButton from './MuiToggleButton';
import MuiTabs from './MuiTabs';
import MuiTab from './MuiTab';
import MuiAccordion from './MuiAccordion';
import MuiAccordionSummary from './MuiAccordionSummary';
import MuiAccordionDetails from './MuiAccordionDetails';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiToggleButtonGroup from './MuiToggleButtonGroup';
import MuiToolbar from './MuiToolbar';
import MuiSnackbar from './MuiSnackbar';
import MuiFab from './MuiFab';
import MuiTypography from './MuiTypography';
import MuiAlert from './MuiAlert';

export default {
  ...MuiButton,
  ...MuiTextField,
  ...MuiInputBase,
  ...MuiFilledInput,
  ...MuiAutocomplete,
  ...MuiDivider,
  ...MuiInputLabel,
  ...MuiDialogContent,
  ...MuiSlider,
  ...MuiToggleButton,
  ...MuiTabs,
  ...MuiTab,
  ...MuiAccordion,
  ...MuiAccordionSummary,
  ...MuiAccordionDetails,
  ...MuiFormControlLabel,
  ...MuiToggleButtonGroup,
  ...MuiToolbar,
  ...MuiSnackbar,
  ...MuiFab,
  ...MuiTypography,
  ...MuiAlert,
};
